<template>
  <div>
    <NavButton chevron :toggled="showMenu" class="hidden md:flex" @click="toggleMenu">
      Nuestros servicios
    </NavButton>
    <NavMenu :show="showMenu" :showing-all-services="showAllServices" @hide="toggleMenu(false)">
      <div class="md:hidden border-t-2 pt-ds-sm mb-ds-xxs mt-ds-sm text-black opacity-50 w-full">Servicios</div>
      <NavMenuItem
        image="nav_removals"
        url="https://www.anyvan.com/es/servicios-de-mudanzas-cerca-de-ti"
        qa-tag="nav-our-services-removals"
        @click="$emit('track', 'our-services', 'removals')"
      >
        Servicios de mudanzas
      </NavMenuItem>
      <NavMenuItem
        image="nav_international"
        url="https://www.anyvan.es/transportes-internacionales"
        qa-tag="nav-our-services-international"
        @click="$emit('track', 'our-services', 'international')"
      >
        Mudanzas internacionales
      </NavMenuItem>
      <NavMenuItem
        image="nav_furniture"
        url="https://www.anyvan.es/transporte-de-muebles"
        qa-tag="nav-our-services-furniture"
        @click="$emit('track', 'our-services', 'furniture')"
      >
        Transporte de muebles
      </NavMenuItem>
      <NavMenuItem
        image="nav_car"
        url="https://www.anyvan.es/transporte-de-vehiculos"
        qa-tag="nav-our-services-car"
        @click="$emit('track', 'our-services', 'car')"
      >
        Transporte de vehículos
      </NavMenuItem>
      <NavMenuItem
        image="nav_motorcycle"
        url="https://www.anyvan.es/transporte-de-motos"
        qa-tag="nav-our-services-motorcycle"
        @click="$emit('track', 'our-services', 'motorcycle')"
      >
        Transporte de motos
      </NavMenuItem>
      <NavMenuItem
        image="nav_piano"
        url="https://www.anyvan.es/transporte-de-pianos"
        qa-tag="nav-our-services-piano"
        @click="$emit('track', 'our-services', 'piano')"
      >
        Transporte de pianos
      </NavMenuItem>
      <NavMenuItem
        image="nav_large"
        url="https://www.anyvan.es/empresas-de-paqueteria"
        qa-tag="nav-all-services-heavy-large-item"
        :full-height-icon="true"
        @click="$emit('track', 'our-services', 'heavy-large-item')"
      >
        Envío de paquetes grandes
      </NavMenuItem>
      <NavMenuItem
        image="nav_ebay"
        url="https://www.anyvan.es/colaboradores-de-ebay"
        qa-tag="nav-all-services-ebay"
        :full-height-icon="true"
        @click="$emit('track', 'our-services', 'ebay')"
      >
        Envío de artículos de eBay
      </NavMenuItem>
      <!-- mobile-only -->
      <NavLoginButton
        services
        redirect-url="https://www.anyvan.es/iniciar-sesion"
        qa-tag="nav-our-services-login"
        class="mt-auto"
      />
      <!-- end mobile-only -->
    </NavMenu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import NavOurServicesBase from "~/components/base/navOurServices"

export default defineComponent({
  name: "NavOurServicesEs",
  extends: NavOurServicesBase
})
</script>
